"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStreamStatusEvmOperation = void 0;
exports.updateStreamStatusEvmOperation = {
    method: 'POST',
    name: 'updateStreamStatusEvm',
    id: 'UpdateStreamStatus',
    groupName: 'evmStreams',
    urlPathParamNames: ['id'],
    urlPathPattern: '/streams/evm/{id}/status',
    bodyParamNames: ['status'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function getRequestBody(request) {
    return {
        status: request.status,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        id: request.id,
        status: request.status,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
        status: jsonRequest.status,
    };
}
//# sourceMappingURL=updateStreamStatusEvmOperation.js.map